<template>
  <div class="montant-selection">
    <div class="mb-6">
      <div class="body-1 strong">Type de don:</div>
      <v-chip-group id="type" ref="typeDeDon" :mandatory="true" :column="true" v-model="typeDeDon">
        <v-chip outlined label v-for="type in typesDeDon" :key="type" large class="px-6">{{ type }}</v-chip>
      </v-chip-group>
    </div>

    <div>
      <div class="body-1 strong">Montant du don:</div>
      <div>
        <v-chip-group
          id="montantSimple"
          ref="montantDonSimple"
          v-if="typeDeDon === 0"
          :mandatory="true"
          :column="true"
          v-model="montantDonSimpleIndex"
        >
          <v-chip v-for="montant in montantsSimplesPossibles" :key="montant.t" large label outlined class="px-6">{{ montant.t }}</v-chip>
        </v-chip-group>
        <v-text-field
          label="Montant"
          v-if="typeDeDon === 0 && montantDonSimpleIndex === montantsSimplesPossibles.length - 1"
          class="mt-3"
          color="black"
          dense
          suffix="$"
          outlined
          type="number"
          step="0.01"
          v-model="montantDuDonSimplePerso"
        ></v-text-field>
      </div>

      <div>
        <v-chip-group
          id="montantMensuel"
          ref="montantDonMensuel"
          v-if="typeDeDon === 1"
          :mandatory="true"
          :column="true"
          v-model="montantDonMensuelIndex"
        >
          <v-chip v-for="montant in montantsMensuelsPossibles" :key="montant.t" label large outlined class="px-6">{{ montant.t }}</v-chip>
        </v-chip-group>
        <div class="mt-3">
          <v-text-field
            label="Montant"
            v-if="typeDeDon === 1 && montantDonMensuelIndex === montantsMensuelsPossibles.length - 1"
            suffix="$/mois"
            color="black"
            outlined
            dense
            type="number"
            step="0.01"
            v-model="montantDuDonMensuelPerso"
          ></v-text-field>
          <v-select label="Jour du prélèvement" v-if="typeDeDon === 1" :items="days" v-model="day" outlined color="black" dense></v-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex"
export default {
  data() {
    return {
      montantDonSimpleIndex: 1,
      montantDonMensuelIndex: 2,
      montantDuDonSimplePerso: "20",
      montantDuDonMensuelPerso: "50",
      days: [],
      day: 1
    }
  },
  computed: {
    ...mapGetters({
      typesDeDon: "getTypesDeDon",
      montantsSimplesPossibles: "getMontantsUniquesPossibles",
      montantsMensuelsPossibles: "getMontantsMensuelsPossibles"
    }),
    typeDeDon: {
      get() {
        return this.$store.state.donate.typeDeDon
      },
      set(value) {
        this.$store.commit("setTypeDeDon", value)
      }
    }
  },
  watch: {
    typeDeDon() {
      this.updateMontantStore()
    },
    montantDonSimpleIndex() {
      this.updateMontantStore()
    },
    montantDonMensuelIndex() {
      this.updateMontantStore()
    },
    montantDuDonSimplePerso() {
      this.validateAmount()
      this.updateMontantStore()
    },
    montantDuDonMensuelPerso() {
      this.validateAmount()
      this.updateMontantStore()
    },
    day() {
      this.setPaymentJour(this.day)
    }
  },
  methods: {
    ...mapMutations(["setPaymentJour", "setMontantDon"]),
    updateMontantStore() {
      var montant = 0
      if (this.typeDeDon === 0) {
        if (this.montantDonSimpleIndex === this.montantsSimplesPossibles.length - 1) {
          montant = parseFloat(this.montantDuDonSimplePerso)
        } else {
          montant = this.montantsSimplesPossibles[this.montantDonSimpleIndex].v
        }
      } else if (this.typeDeDon === 1) {
        if (this.montantDonMensuelIndex === this.montantsMensuelsPossibles.length - 1) {
          montant = parseFloat(this.montantDuDonMensuelPerso)
        } else {
          montant = this.montantsMensuelsPossibles[this.montantDonMensuelIndex].v
        }
      }
      this.setMontantDon(montant)
    },
    validateAmount() {
      var montant = 0
      if (this.typeDeDon === 0) {
        montant = parseFloat(this.montantDuDonSimplePerso)
        if (montant < 0) {
          this.montantDuDonSimplePerso = -montant
        }
      } else if (this.typeDeDon === 1) {
        montant = parseFloat(this.montantDuDonMensuelPerso)
        if (montant < 0) {
          this.montantDuDonMensuelPerso = -montant
        }
      }
    }
  },
  created() {
    for (var i = 1; i <= 28; i++) {
      this.days.push(i)
    }
  },
  mounted() {
    this.updateMontantStore()
  }
}
</script>

<style>
</style>